module.exports = __webpack_public_path__ + "img/toumingmofakoudaiWu.min.c5ac8de7.png";